module.exports = __webpack_public_path__ + "static/media/thumbnail.76bb7d58.jpg";